export default __webpack_public_path__ + "static/media/img-03.1af6fd6b.jpg";